<template>
    <div class="step-categories">
        <h4>
            Zaznacz wszystkie kategorie<br class="hide-lg"/>
            dotyczące Twojego profilu
        </h4>
        <div class="category-boxes-section small-form" v-if="!isLg" v-for="(section, sectionIndex) in getDividedSections()">
            <div class="category-boxes-row">
                <category-box v-for="categoryIndex in section" v-model="currentCategory" :value="currentCategory" :index="categoryIndex" :data="categories[categoryIndex]" :checked-values="values" v-if="values" />
            </div>

            <div class="categories-form" v-if="!isLg">
                <checkboxes-form :value="values" :data="categories[currentCategory]" v-on:update="updateForm" :visible="section.indexOf(currentCategory) !== -1" />
            </div>
        </div>

        <div class="lg-wrap" v-if="isLg">

            <div class="category-boxes-section hidden-form">
                <category-box v-for="(category, categoryIndex) in categories" v-model="currentCategory" :value="currentCategory" :index="categoryIndex" :data="category" :checked-values="values" v-if="values" />
            </div>

            <div class="form-section hidden-form">
                <div class="categories-form">
                    <checkboxes-form v-if="categories[currentCategory]" :value="values" :data="categories[currentCategory]" v-on:update="updateForm" :visible="true" />
                </div>
            </div>

        </div>

        <spacer />

        <div class="navigation">
            <button v-on:click="goBack" type="button" class="go-back-button"></button>
            <button v-on:click="nextStep" type="button" class="submit-purple-button">Dalej</button>
        </div>
    </div>
</template>

<script>
    import CheckboxesForm from "./elements/CheckboxesForm";
    import CategoryBox from "./elements/CategoryBox";
    import Spacer from "../Spacer";
    export default {
        name: "StepCategories",
        components: {Spacer, CategoryBox, CheckboxesForm},
        props: ["categories", "submittedData"],
        data: function() {
            return {
                values: false,
                currentCategory: -1,
                itemsPerRow: 3,
                windowWidth: 0,
                isLg: false,
                breakPoint: 1000
            }
        },
        watch: {
            windowWidth(newWidth, oldWidth) {
                this.isLg = (newWidth >= this.breakPoint);
            },
            isLg() {
                if(this.isLg) {
                    this.currentCategory = 0;
                }
            }
        },
        mounted() {
            if(this.submittedData) {
                this.values = this.submittedData;
            }

            this.windowWidth = window.innerWidth;

            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.windowWidth = window.innerWidth
                });
            });
        },
        methods: {
            nextStep: function () {
                if(!this.values.length) {
                    this.$notify({
                        group: 'form',
                        type: 'warn',
                        title: 'Wybierz swoje zainteresowania'
                    });
                }
                else {
                    this.$emit('submit-data', this.values);
                }
            },
            goBack: function () {
                this.$emit('go-back');
            },
            getDividedSections() {
              let sections = [];

              let currentSection = 0;

              for(let i = 0; i < this.categories.length; i++) {

                  let check = i + 1;

                  if(typeof sections[currentSection] === 'undefined') {
                      sections[currentSection] = [];
                  }
                  sections[currentSection].push(i);
                  if(check % 3 === 0) currentSection += 1;
              }

              return sections;
            },
            updateForm(data) {
                for(let i = 0; i < data.checkedValues.length; i++) {
                    if(this.values.indexOf(data.checkedValues[i]) !== -1) continue;
                    this.values.push(data.checkedValues[i]);
                }

                for(let i = 0; i < data.uncheckedValues.length; i++) {
                    let index = this.values.indexOf(data.uncheckedValues[i]);
                    if (index > -1) {
                        this.values.splice(index, 1);
                    }
                }

            }
        }

    }
</script>

<style scoped lang="scss">

</style>